const constants = {
  GET_REPORT_PENDING: 'GET_REPORT_PENDING',
  GET_REPORT_SUCCESS: 'GET_REPORT_SUCCESS',
  GET_REPORT_FAILURE: 'GET_REPORT_FAILURE',
};

export default constants;
